import { render, staticRenderFns } from "./SelectArchArticle.vue?vue&type=template&id=4ec8da18&"
import script from "./SelectArchArticle.vue?vue&type=script&lang=js&"
export * from "./SelectArchArticle.vue?vue&type=script&lang=js&"
import style0 from "./SelectArchArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports